// 2026-10-05 · Admin › Versiones: «limpiar caché» de este dispositivo.
//
//  - soft: borra la Cache Storage del navegador, pide al service worker que se
//    actualice y recarga → arranca con el último build. NO toca localStorage:
//    se mantienen la sesión, el empleado activo y los carritos sin guardar de
//    cada mesa (checkoutHistory / redux-persist / tmoQr:*).
//  - full: además quita el service worker, purga redux-persist, vacía
//    localStorage (salvo tmoQr:*) y sessionStorage y vuelve a la raíz → hay
//    que volver a iniciar sesión. Se pierden los carritos sin guardar.
//
// `preserveKeys`: claves de localStorage que sobreviven también a la full
// (p. ej. las órdenes ya ejecutadas, para no repetirlas tras recargar).
import { clearLocalStoragePreservingQr } from "src/utils/tmoQrStorage";

export const CLEAR_MODES = ["soft", "full"];

function defaultPersistor() {
  try {
    // Import perezoso: evita el ciclo store ↔ utils al cargar.
    // eslint-disable-next-line global-require
    return require("src/redux/store").persistor;
  } catch {
    return null;
  }
}

export async function clearAppCache(
  mode = "soft",
  { win = window, persistor = defaultPersistor(), preserveKeys = [], reload = true } = {},
) {
  const full = mode === "full";
  const report = { mode: full ? "full" : "soft", caches: 0, serviceWorkers: 0 };

  try {
    if (win.caches && typeof win.caches.keys === "function") {
      const keys = await win.caches.keys();
      await Promise.all(keys.map((k) => win.caches.delete(k)));
      report.caches = keys.length;
    }
  } catch {
    /* sin Cache Storage (http, modo privado): nada que borrar */
  }

  try {
    const sw = win.navigator && win.navigator.serviceWorker;
    const regs = sw && typeof sw.getRegistrations === "function" ? await sw.getRegistrations() : [];
    for (const reg of regs) {
      // eslint-disable-next-line no-await-in-loop
      if (full) await reg.unregister();
      // eslint-disable-next-line no-await-in-loop
      else await reg.update();
    }
    report.serviceWorkers = regs.length;
  } catch {
    /* el SW solo lleva las notificaciones: si falla, seguimos */
  }

  if (full) {
    const kept = {};
    preserveKeys.forEach((k) => {
      try {
        const v = win.localStorage.getItem(k);
        if (v != null) kept[k] = v;
      } catch {
        /* ignore */
      }
    });
    try {
      if (persistor) {
        persistor.pause();
        await persistor.purge();
      }
    } catch {
      /* ignore */
    }
    clearLocalStoragePreservingQr();
    try {
      win.sessionStorage.clear();
    } catch {
      /* ignore */
    }
    Object.entries(kept).forEach(([k, v]) => {
      try {
        win.localStorage.setItem(k, v);
      } catch {
        /* ignore */
      }
    });
  }

  if (reload) {
    if (full) win.location.replace("/");
    else win.location.reload();
  }
  return report;
}

export default clearAppCache;
